import PipelineEditContainer from './containers/PipelineEditContainer'

export default PipelineEditContainer
